module.exports = __webpack_public_path__ + "img/stack_1.52eed564.png";